import EventListenerLogClient from '../../../../api/clients/events/EventListenerLogClient'
import { LogTableFilters } from '../../../../components/tables/DTO'
import { LogTable } from '../../../../controls/specifics/logs/LogTable'

type EventListenerLogSectionProps = {
	eventListenerId?: number
}

export const EventListenerLogSection = (props: EventListenerLogSectionProps) => {
	const logClient = new EventListenerLogClient()

	const getEntries = (filters: LogTableFilters) =>
		logClient.getEventListenerLog({
			...filters,
			eventListenerId: props.eventListenerId,
		}).then((response) => response.data)

	const getEntriesCount = (filters: LogTableFilters) =>
		logClient.getEventListenerLogCount({
			...filters,
			eventListenerId: props.eventListenerId,
		}).then((response) => response.data)

	return (
		<LogTable
			getEntries={getEntries}
			getEntriesCount={getEntriesCount}
		/>
	)
}